import React from 'react';
import Table from '../UI/Table/Table';
import DeleteButton from '../UI/Buttons/DeleteButton';
import CopyButton from '../UI/Buttons/CopyButton';

const media_table_columns = [
  {title: 'Name', key_name: 'name', order: 1, feature_activated: true},
  {title: 'Image', key_name: 'image', order: 2, feature_activated: true},
  {title: 'Actions', key_name: 'actions', order: 3, feature_activated: true},
];

const MediaManagerList = ({media_list, deleteP, writeP, onDelete}) => {
  return (
    <Table
      header_data={media_table_columns.map(item => {
        const center_keys = ['image', 'actions'];
        return {
          title: item.title,
          key: item.key_name,
          className: [
            'text-sm font-medium    px-4 py-3  flex-grow  whitespace-nowrap min-w-[140px] ',
            center_keys?.includes(item?.key_name)
              ? 'text-center'
              : 'text-start',
          ].join(' '),
        };
      })}
      table_header_style={'  '}
      table_style=" block border-0  rounded-none  !mt-0 table-auto w-full  max-h-full h-full overflow-auto  overflow-auto ">
      {media_list?.map(media => {
        return (
          <tr className="  w-full   border-b border-[#e6e7e7]  bg-white">
            {media_table_columns
              ?.filter(it => it?.feature_activated)
              ?.map(column => {
                console.log(media);
                switch (column.key_name) {
                  case 'name':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2  min-w-[300px] w-full  ">
                        {media?.name
                          ? media?.name
                          : media?.url?.substring(
                              media?.url?.lastIndexOf('/') + 1,
                            )}
                      </td>
                    );

                  case 'image':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 whitespace-nowrap my-auto">
                        <div className="flex items-center justify-center min-h-[50px]">
                          {media?.mime_type?.startsWith('image') && (
                            <img
                              src={media?.url}
                              alt={media?.name}
                              className="h-[50px] w-[50px] rounded-[10px] mx-auto"
                            />
                          )}
                        </div>
                      </td>
                    );

                  case 'actions':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 px-4 text-AppTitleBlack">
                        <div className="flex items-center justify-center gap-2">
                          {deleteP && (
                            <DeleteButton
                              onClickDelete={() => onDelete(media?.id)}
                            />
                          )}
                          <CopyButton copy_item={media?.url} />
                        </div>
                      </td>
                    );

                  default:
                    return null;
                }
              })}
          </tr>
        );
      })}
    </Table>
  );
};

export default MediaManagerList;
